import { NavigationBarContainer } from 'styles/components/common/NavigationBarStyle';
import { Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { CommonWrapper } from 'styles/common/Layout';

const NavigationBar = () => {
  const navigation = [
    {
      label: '홈',
      link: '/home',
      icon: 'home',
    },
    {
      label: '이용 안내',
      link: '/guide',
      icon: 'info',
    },
    {
      label: '내 정보',
      link: '/my',
      icon: 'person',
    },
    {
      label: '설정',
      link: '/setting',
      icon: 'settings',
    },
  ];
  return (
    <NavigationBarContainer>
      <CommonWrapper>
        <Row className="justify-content-sm-center py-2">
          {navigation.map((item) => {
            return (
              <Col className="text-center">
                <NavLink to={item.link}>
                  <span class="material-symbols-outlined">{item.icon}</span>
                  <p>{item.label}</p>
                </NavLink>
              </Col>
            );
          })}
        </Row>
      </CommonWrapper>
    </NavigationBarContainer>
  );
};

export default NavigationBar;
